import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SudoProvider } from './components/SudoProvider';
import { ThemeProvider } from './components/ThemeContext';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

async function bootstrap() {
  // Optional MSW browser worker — opt-in via VITE_MSW=1 (dev / E2E only).
  // When enabled, /api/* + /upload/* requests are served from canned
  // handlers in src/mocks/handlers.ts (no backend required).
  if (import.meta.env.VITE_MSW === '1') {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  createRoot(root!).render(
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <SudoProvider>
              <App />
            </SudoProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>,
  );
}

void bootstrap();
